import React from 'react';
import classnames from 'classnames';

import { IDocViewIFrameProps } from './DocumentViewer';

interface IGoogleDocsIFrameState {
  isLoaded: boolean;
  retries: number;
}

export default class GoogleDocsIFrame extends React.Component<IDocViewIFrameProps, IGoogleDocsIFrameState> {
  private iframeTimeoutId;
  private iframeRef;

  constructor(props: IDocViewIFrameProps) {
    super(props);
    this.state = { isLoaded: false, retries: 5 };
  }

  iframeLoaded = () => {
    this.setState({
      isLoaded: true,
    });
    clearTimeout(this.iframeTimeoutId);
  };

  getIframeLink = () =>
    // tslint:disable-next-line: max-line-length
    ` https://docs.google.com/a/umd.edu/viewer?url=${this.props.fileURL}&embedded=true`;

  updateIframeSrc = () => {
    if (!this.state.isLoaded && this.state.retries > 0) {
      this.setState(
        (lastState) => ({
          retries: lastState.retries - 1,
        }),
        () => {
          clearTimeout(this.iframeTimeoutId);
          const iframe = this.iframeRef as HTMLIFrameElement;
          iframe.src = this.getIframeLink();
          this.iframeTimeoutId = setTimeout(this.updateIframeSrc, 5000);
        }
      );
    } else {
      this.props.onError();
    }
  };

  componentDidMount = () => {
    this.iframeTimeoutId = setTimeout(this.updateIframeSrc, 5000);
  };

  componentWillUnmount() {
    clearTimeout(this.iframeTimeoutId);
  }

  render() {
    const loaderStyle: React.CSSProperties = {
      position: 'absolute',
      left: 'calc(50% - 100px)',
      top: 'calc(50% - 100px)',
    };

    return (
      <div className={classnames('doc-viewer__content__iframe')}>
        {!this.state.isLoaded && <img style={loaderStyle} src="/assets/loading.gif" />}
        <iframe
          onLoad={this.iframeLoaded}
          onError={this.updateIframeSrc}
          ref={(ref) => {
            this.iframeRef = ref;
          }}
          width="100%"
          height="100%"
          src={this.getIframeLink()}
        />
      </div>
    );
  }
}
